import { useCallback } from "react";
import { useSetRecoilState } from "recoil";

import {
  ConfirmResult,
  ISoftValidationModalPayloadData,
  softValidationErrorAtom,
} from "@ryde/shared";

export const useSoftValidationModalConfirm = () => {
  const setSoftValidationError = useSetRecoilState(softValidationErrorAtom);

  const confirmSoftValidationAction = useCallback(
    async (data: ISoftValidationModalPayloadData): Promise<ConfirmResult> => {
      return new Promise(resolve => {
        setSoftValidationError({ resolveFn: resolve, data });
      });
    },
    [setSoftValidationError],
  );

  return {
    confirmSoftValidationAction,
  };
};
